
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("bc9sC"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("5gCWX"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("fPoXI"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("8bZwi"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("ejTSw"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("azN5s"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("Kd9RL"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("eppxR"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("4eWti"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("fUm9P"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("94aeZ"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("jKDx8"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("bc9sC", function(module, exports) {

let $8268275d7103536c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8268275d7103536c$var$load("2YffH"),
    $8268275d7103536c$var$load("1o23t"),
    $8268275d7103536c$var$load("lqFMg"),
    $8268275d7103536c$var$load("6ppWw"),
    $8268275d7103536c$var$load("dV96N"),
    $8268275d7103536c$var$load("iQ0Jm"),
    $8268275d7103536c$var$load("4QkRU"),
    $8268275d7103536c$var$load("eBRUf"),
    $8268275d7103536c$var$load("g2Huf"),
    $8268275d7103536c$var$load("cOwGZ"),
    $8268275d7103536c$var$load("44eor"),
    $8268275d7103536c$var$load("8faeS"),
    $8268275d7103536c$var$load("h4Nf7"),
    $8268275d7103536c$var$load("7f9Fz"),
    $8268275d7103536c$var$load("8YSo7"),
    $8268275d7103536c$var$load("i8VlQ"),
    $8268275d7103536c$var$load("7do1E"),
    $8268275d7103536c$var$load("77dkW"),
    $8268275d7103536c$var$load("g9CVe"),
    $8268275d7103536c$var$load("4t1qI"),
    $8268275d7103536c$var$load("fSobj"),
    $8268275d7103536c$var$load("74u2y"),
    $8268275d7103536c$var$load("6wr18"),
    $8268275d7103536c$var$load("kjZZD"),
    $8268275d7103536c$var$load("jsqco"),
    $8268275d7103536c$var$load("851iy"),
    $8268275d7103536c$var$load("kHOMt"),
    $8268275d7103536c$var$load("dRpV3"),
    $8268275d7103536c$var$load("ffEVr"),
    $8268275d7103536c$var$load("jwTn5"),
    $8268275d7103536c$var$load("aYdgM"),
    $8268275d7103536c$var$load("6u1hm"),
    $8268275d7103536c$var$load("9vLZO"),
    $8268275d7103536c$var$load("hx8rI"),
    $8268275d7103536c$var$load("2vAWg"),
    $8268275d7103536c$var$load("7cABH"),
    $8268275d7103536c$var$load("4UuEP"),
    $8268275d7103536c$var$load("75xVF"),
    $8268275d7103536c$var$load("2uVTT"),
    $8268275d7103536c$var$load("hhss7"),
    $8268275d7103536c$var$load("Wowvf"),
    $8268275d7103536c$var$load("cJcjb"),
    $8268275d7103536c$var$load("hJpvQ"),
    $8268275d7103536c$var$load("bIPPg"),
    $8268275d7103536c$var$load("lnKog"),
    $8268275d7103536c$var$load("9ftJe"),
    $8268275d7103536c$var$load("h3ABO"),
    $8268275d7103536c$var$load("kC80R"),
    $8268275d7103536c$var$load("7EorR"),
    $8268275d7103536c$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("5gCWX", function(module, exports) {

let $3d5ca908c4a48df0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3d5ca908c4a48df0$var$load("2YffH"),
    $3d5ca908c4a48df0$var$load("1o23t"),
    $3d5ca908c4a48df0$var$load("lqFMg"),
    $3d5ca908c4a48df0$var$load("6ppWw"),
    $3d5ca908c4a48df0$var$load("dV96N"),
    $3d5ca908c4a48df0$var$load("iQ0Jm"),
    $3d5ca908c4a48df0$var$load("4QkRU"),
    $3d5ca908c4a48df0$var$load("eBRUf"),
    $3d5ca908c4a48df0$var$load("g2Huf"),
    $3d5ca908c4a48df0$var$load("cOwGZ"),
    $3d5ca908c4a48df0$var$load("44eor"),
    $3d5ca908c4a48df0$var$load("8faeS"),
    $3d5ca908c4a48df0$var$load("h4Nf7"),
    $3d5ca908c4a48df0$var$load("7f9Fz"),
    $3d5ca908c4a48df0$var$load("8YSo7"),
    $3d5ca908c4a48df0$var$load("i8VlQ"),
    $3d5ca908c4a48df0$var$load("7do1E"),
    $3d5ca908c4a48df0$var$load("77dkW"),
    $3d5ca908c4a48df0$var$load("g9CVe"),
    $3d5ca908c4a48df0$var$load("4t1qI"),
    $3d5ca908c4a48df0$var$load("fSobj"),
    $3d5ca908c4a48df0$var$load("74u2y"),
    $3d5ca908c4a48df0$var$load("6wr18"),
    $3d5ca908c4a48df0$var$load("kjZZD"),
    $3d5ca908c4a48df0$var$load("jsqco"),
    $3d5ca908c4a48df0$var$load("851iy"),
    $3d5ca908c4a48df0$var$load("kHOMt"),
    $3d5ca908c4a48df0$var$load("dRpV3"),
    $3d5ca908c4a48df0$var$load("ffEVr"),
    $3d5ca908c4a48df0$var$load("jwTn5"),
    $3d5ca908c4a48df0$var$load("aYdgM"),
    $3d5ca908c4a48df0$var$load("6u1hm"),
    $3d5ca908c4a48df0$var$load("9vLZO"),
    $3d5ca908c4a48df0$var$load("hx8rI"),
    $3d5ca908c4a48df0$var$load("2vAWg"),
    $3d5ca908c4a48df0$var$load("7cABH"),
    $3d5ca908c4a48df0$var$load("4UuEP"),
    $3d5ca908c4a48df0$var$load("75xVF"),
    $3d5ca908c4a48df0$var$load("2uVTT"),
    $3d5ca908c4a48df0$var$load("hhss7"),
    $3d5ca908c4a48df0$var$load("Wowvf"),
    $3d5ca908c4a48df0$var$load("cJcjb"),
    $3d5ca908c4a48df0$var$load("hJpvQ"),
    $3d5ca908c4a48df0$var$load("bIPPg"),
    $3d5ca908c4a48df0$var$load("lnKog"),
    $3d5ca908c4a48df0$var$load("9ftJe"),
    $3d5ca908c4a48df0$var$load("h3ABO"),
    $3d5ca908c4a48df0$var$load("kC80R"),
    $3d5ca908c4a48df0$var$load("7EorR"),
    $3d5ca908c4a48df0$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("fPoXI", function(module, exports) {

let $b85efb60314c1bbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b85efb60314c1bbe$var$load("2YffH"),
    $b85efb60314c1bbe$var$load("1o23t"),
    $b85efb60314c1bbe$var$load("lqFMg"),
    $b85efb60314c1bbe$var$load("6ppWw"),
    $b85efb60314c1bbe$var$load("dV96N"),
    $b85efb60314c1bbe$var$load("iQ0Jm"),
    $b85efb60314c1bbe$var$load("4QkRU"),
    $b85efb60314c1bbe$var$load("eBRUf"),
    $b85efb60314c1bbe$var$load("g2Huf"),
    $b85efb60314c1bbe$var$load("cOwGZ"),
    $b85efb60314c1bbe$var$load("44eor"),
    $b85efb60314c1bbe$var$load("8faeS"),
    $b85efb60314c1bbe$var$load("h4Nf7"),
    $b85efb60314c1bbe$var$load("7f9Fz"),
    $b85efb60314c1bbe$var$load("8YSo7"),
    $b85efb60314c1bbe$var$load("i8VlQ"),
    $b85efb60314c1bbe$var$load("7do1E"),
    $b85efb60314c1bbe$var$load("77dkW"),
    $b85efb60314c1bbe$var$load("g9CVe"),
    $b85efb60314c1bbe$var$load("4t1qI"),
    $b85efb60314c1bbe$var$load("fSobj"),
    $b85efb60314c1bbe$var$load("74u2y"),
    $b85efb60314c1bbe$var$load("6wr18"),
    $b85efb60314c1bbe$var$load("kjZZD"),
    $b85efb60314c1bbe$var$load("jsqco"),
    $b85efb60314c1bbe$var$load("851iy"),
    $b85efb60314c1bbe$var$load("kHOMt"),
    $b85efb60314c1bbe$var$load("dRpV3"),
    $b85efb60314c1bbe$var$load("ffEVr"),
    $b85efb60314c1bbe$var$load("jwTn5"),
    $b85efb60314c1bbe$var$load("aYdgM"),
    $b85efb60314c1bbe$var$load("6u1hm"),
    $b85efb60314c1bbe$var$load("9vLZO"),
    $b85efb60314c1bbe$var$load("hx8rI"),
    $b85efb60314c1bbe$var$load("2vAWg"),
    $b85efb60314c1bbe$var$load("7cABH"),
    $b85efb60314c1bbe$var$load("4UuEP"),
    $b85efb60314c1bbe$var$load("75xVF"),
    $b85efb60314c1bbe$var$load("2uVTT"),
    $b85efb60314c1bbe$var$load("hhss7"),
    $b85efb60314c1bbe$var$load("Wowvf"),
    $b85efb60314c1bbe$var$load("cJcjb"),
    $b85efb60314c1bbe$var$load("hJpvQ"),
    $b85efb60314c1bbe$var$load("bIPPg"),
    $b85efb60314c1bbe$var$load("lnKog"),
    $b85efb60314c1bbe$var$load("9ftJe"),
    $b85efb60314c1bbe$var$load("h3ABO"),
    $b85efb60314c1bbe$var$load("kC80R"),
    $b85efb60314c1bbe$var$load("7EorR"),
    $b85efb60314c1bbe$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("8bZwi", function(module, exports) {

let $5f6f126685b0679c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5f6f126685b0679c$var$load("7do1E"),
    $5f6f126685b0679c$var$load("77dkW"),
    $5f6f126685b0679c$var$load("2YffH"),
    $5f6f126685b0679c$var$load("lqFMg"),
    $5f6f126685b0679c$var$load("6ppWw"),
    $5f6f126685b0679c$var$load("dV96N"),
    $5f6f126685b0679c$var$load("hJpvQ"),
    $5f6f126685b0679c$var$load("eBRUf"),
    $5f6f126685b0679c$var$load("g2Huf"),
    $5f6f126685b0679c$var$load("cOwGZ"),
    $5f6f126685b0679c$var$load("44eor"),
    $5f6f126685b0679c$var$load("8faeS"),
    $5f6f126685b0679c$var$load("h4Nf7"),
    $5f6f126685b0679c$var$load("7f9Fz"),
    $5f6f126685b0679c$var$load("8YSo7"),
    $5f6f126685b0679c$var$load("i8VlQ"),
    $5f6f126685b0679c$var$load("g9CVe"),
    $5f6f126685b0679c$var$load("4t1qI"),
    $5f6f126685b0679c$var$load("fSobj"),
    $5f6f126685b0679c$var$load("74u2y"),
    $5f6f126685b0679c$var$load("6wr18"),
    $5f6f126685b0679c$var$load("kjZZD"),
    $5f6f126685b0679c$var$load("jsqco"),
    $5f6f126685b0679c$var$load("851iy"),
    $5f6f126685b0679c$var$load("kHOMt"),
    $5f6f126685b0679c$var$load("dRpV3"),
    $5f6f126685b0679c$var$load("ffEVr"),
    $5f6f126685b0679c$var$load("jwTn5"),
    $5f6f126685b0679c$var$load("aYdgM"),
    $5f6f126685b0679c$var$load("6u1hm"),
    $5f6f126685b0679c$var$load("9vLZO"),
    $5f6f126685b0679c$var$load("hx8rI"),
    $5f6f126685b0679c$var$load("2vAWg"),
    $5f6f126685b0679c$var$load("7cABH"),
    $5f6f126685b0679c$var$load("4UuEP"),
    $5f6f126685b0679c$var$load("75xVF"),
    $5f6f126685b0679c$var$load("bIPPg"),
    $5f6f126685b0679c$var$load("2uVTT"),
    $5f6f126685b0679c$var$load("hhss7"),
    $5f6f126685b0679c$var$load("Wowvf"),
    $5f6f126685b0679c$var$load("cJcjb"),
    $5f6f126685b0679c$var$load("9ftJe"),
    $5f6f126685b0679c$var$load("h3ABO"),
    $5f6f126685b0679c$var$load("kC80R"),
    $5f6f126685b0679c$var$load("7EorR"),
    $5f6f126685b0679c$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("ejTSw", function(module, exports) {

let $a6ce2f4f310e0a49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a6ce2f4f310e0a49$var$load("7do1E"),
    $a6ce2f4f310e0a49$var$load("77dkW"),
    $a6ce2f4f310e0a49$var$load("2YffH"),
    $a6ce2f4f310e0a49$var$load("lqFMg"),
    $a6ce2f4f310e0a49$var$load("6ppWw"),
    $a6ce2f4f310e0a49$var$load("dV96N"),
    $a6ce2f4f310e0a49$var$load("hJpvQ"),
    $a6ce2f4f310e0a49$var$load("eBRUf"),
    $a6ce2f4f310e0a49$var$load("g2Huf"),
    $a6ce2f4f310e0a49$var$load("cOwGZ"),
    $a6ce2f4f310e0a49$var$load("44eor"),
    $a6ce2f4f310e0a49$var$load("8faeS"),
    $a6ce2f4f310e0a49$var$load("h4Nf7"),
    $a6ce2f4f310e0a49$var$load("7f9Fz"),
    $a6ce2f4f310e0a49$var$load("8YSo7"),
    $a6ce2f4f310e0a49$var$load("i8VlQ"),
    $a6ce2f4f310e0a49$var$load("g9CVe"),
    $a6ce2f4f310e0a49$var$load("4t1qI"),
    $a6ce2f4f310e0a49$var$load("fSobj"),
    $a6ce2f4f310e0a49$var$load("74u2y"),
    $a6ce2f4f310e0a49$var$load("6wr18"),
    $a6ce2f4f310e0a49$var$load("kjZZD"),
    $a6ce2f4f310e0a49$var$load("jsqco"),
    $a6ce2f4f310e0a49$var$load("851iy"),
    $a6ce2f4f310e0a49$var$load("kHOMt"),
    $a6ce2f4f310e0a49$var$load("dRpV3"),
    $a6ce2f4f310e0a49$var$load("ffEVr"),
    $a6ce2f4f310e0a49$var$load("jwTn5"),
    $a6ce2f4f310e0a49$var$load("aYdgM"),
    $a6ce2f4f310e0a49$var$load("6u1hm"),
    $a6ce2f4f310e0a49$var$load("9vLZO"),
    $a6ce2f4f310e0a49$var$load("hx8rI"),
    $a6ce2f4f310e0a49$var$load("2vAWg"),
    $a6ce2f4f310e0a49$var$load("7cABH"),
    $a6ce2f4f310e0a49$var$load("4UuEP"),
    $a6ce2f4f310e0a49$var$load("75xVF"),
    $a6ce2f4f310e0a49$var$load("bIPPg"),
    $a6ce2f4f310e0a49$var$load("2uVTT"),
    $a6ce2f4f310e0a49$var$load("hhss7"),
    $a6ce2f4f310e0a49$var$load("Wowvf"),
    $a6ce2f4f310e0a49$var$load("cJcjb"),
    $a6ce2f4f310e0a49$var$load("9ftJe"),
    $a6ce2f4f310e0a49$var$load("h3ABO"),
    $a6ce2f4f310e0a49$var$load("kC80R"),
    $a6ce2f4f310e0a49$var$load("7EorR"),
    $a6ce2f4f310e0a49$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("azN5s", function(module, exports) {

let $7b333ff03824a19e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7b333ff03824a19e$var$load("7do1E"),
    $7b333ff03824a19e$var$load("77dkW"),
    $7b333ff03824a19e$var$load("2YffH"),
    $7b333ff03824a19e$var$load("lqFMg"),
    $7b333ff03824a19e$var$load("6ppWw"),
    $7b333ff03824a19e$var$load("dV96N"),
    $7b333ff03824a19e$var$load("hJpvQ"),
    $7b333ff03824a19e$var$load("eBRUf"),
    $7b333ff03824a19e$var$load("g2Huf"),
    $7b333ff03824a19e$var$load("cOwGZ"),
    $7b333ff03824a19e$var$load("44eor"),
    $7b333ff03824a19e$var$load("8faeS"),
    $7b333ff03824a19e$var$load("h4Nf7"),
    $7b333ff03824a19e$var$load("7f9Fz"),
    $7b333ff03824a19e$var$load("8YSo7"),
    $7b333ff03824a19e$var$load("i8VlQ"),
    $7b333ff03824a19e$var$load("g9CVe"),
    $7b333ff03824a19e$var$load("4t1qI"),
    $7b333ff03824a19e$var$load("fSobj"),
    $7b333ff03824a19e$var$load("74u2y"),
    $7b333ff03824a19e$var$load("6wr18"),
    $7b333ff03824a19e$var$load("kjZZD"),
    $7b333ff03824a19e$var$load("jsqco"),
    $7b333ff03824a19e$var$load("851iy"),
    $7b333ff03824a19e$var$load("kHOMt"),
    $7b333ff03824a19e$var$load("dRpV3"),
    $7b333ff03824a19e$var$load("ffEVr"),
    $7b333ff03824a19e$var$load("jwTn5"),
    $7b333ff03824a19e$var$load("aYdgM"),
    $7b333ff03824a19e$var$load("6u1hm"),
    $7b333ff03824a19e$var$load("9vLZO"),
    $7b333ff03824a19e$var$load("hx8rI"),
    $7b333ff03824a19e$var$load("2vAWg"),
    $7b333ff03824a19e$var$load("7cABH"),
    $7b333ff03824a19e$var$load("4UuEP"),
    $7b333ff03824a19e$var$load("75xVF"),
    $7b333ff03824a19e$var$load("bIPPg"),
    $7b333ff03824a19e$var$load("2uVTT"),
    $7b333ff03824a19e$var$load("hhss7"),
    $7b333ff03824a19e$var$load("Wowvf"),
    $7b333ff03824a19e$var$load("cJcjb"),
    $7b333ff03824a19e$var$load("9ftJe"),
    $7b333ff03824a19e$var$load("h3ABO"),
    $7b333ff03824a19e$var$load("kC80R"),
    $7b333ff03824a19e$var$load("7EorR"),
    $7b333ff03824a19e$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("Kd9RL", function(module, exports) {

let $08ae80ec587e21d2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08ae80ec587e21d2$var$load("7do1E"),
    $08ae80ec587e21d2$var$load("77dkW"),
    $08ae80ec587e21d2$var$load("2YffH"),
    $08ae80ec587e21d2$var$load("lqFMg"),
    $08ae80ec587e21d2$var$load("6ppWw"),
    $08ae80ec587e21d2$var$load("dV96N"),
    $08ae80ec587e21d2$var$load("eBRUf"),
    $08ae80ec587e21d2$var$load("g2Huf"),
    $08ae80ec587e21d2$var$load("cOwGZ"),
    $08ae80ec587e21d2$var$load("44eor"),
    $08ae80ec587e21d2$var$load("8faeS"),
    $08ae80ec587e21d2$var$load("h4Nf7"),
    $08ae80ec587e21d2$var$load("7f9Fz"),
    $08ae80ec587e21d2$var$load("8YSo7"),
    $08ae80ec587e21d2$var$load("i8VlQ"),
    $08ae80ec587e21d2$var$load("g9CVe"),
    $08ae80ec587e21d2$var$load("4t1qI"),
    $08ae80ec587e21d2$var$load("fSobj"),
    $08ae80ec587e21d2$var$load("74u2y"),
    $08ae80ec587e21d2$var$load("6wr18"),
    $08ae80ec587e21d2$var$load("kjZZD"),
    $08ae80ec587e21d2$var$load("jsqco"),
    $08ae80ec587e21d2$var$load("851iy"),
    $08ae80ec587e21d2$var$load("kHOMt"),
    $08ae80ec587e21d2$var$load("dRpV3"),
    $08ae80ec587e21d2$var$load("ffEVr"),
    $08ae80ec587e21d2$var$load("jwTn5"),
    $08ae80ec587e21d2$var$load("aYdgM"),
    $08ae80ec587e21d2$var$load("6u1hm"),
    $08ae80ec587e21d2$var$load("9vLZO"),
    $08ae80ec587e21d2$var$load("hx8rI"),
    $08ae80ec587e21d2$var$load("2vAWg"),
    $08ae80ec587e21d2$var$load("7cABH"),
    $08ae80ec587e21d2$var$load("4UuEP"),
    $08ae80ec587e21d2$var$load("75xVF"),
    $08ae80ec587e21d2$var$load("2uVTT"),
    $08ae80ec587e21d2$var$load("hhss7"),
    $08ae80ec587e21d2$var$load("Wowvf"),
    $08ae80ec587e21d2$var$load("cJcjb"),
    $08ae80ec587e21d2$var$load("hJpvQ"),
    $08ae80ec587e21d2$var$load("bIPPg"),
    $08ae80ec587e21d2$var$load("lnKog"),
    $08ae80ec587e21d2$var$load("9ftJe"),
    $08ae80ec587e21d2$var$load("h3ABO"),
    $08ae80ec587e21d2$var$load("kC80R"),
    $08ae80ec587e21d2$var$load("7EorR"),
    $08ae80ec587e21d2$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("eppxR", function(module, exports) {

let $a7d73733e3af3ae6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a7d73733e3af3ae6$var$load("2YffH"),
    $a7d73733e3af3ae6$var$load("lqFMg"),
    $a7d73733e3af3ae6$var$load("6ppWw"),
    $a7d73733e3af3ae6$var$load("dV96N"),
    $a7d73733e3af3ae6$var$load("4QkRU"),
    $a7d73733e3af3ae6$var$load("eBRUf"),
    $a7d73733e3af3ae6$var$load("g2Huf"),
    $a7d73733e3af3ae6$var$load("cOwGZ"),
    $a7d73733e3af3ae6$var$load("44eor"),
    $a7d73733e3af3ae6$var$load("8faeS"),
    $a7d73733e3af3ae6$var$load("h4Nf7"),
    $a7d73733e3af3ae6$var$load("7f9Fz"),
    $a7d73733e3af3ae6$var$load("8YSo7"),
    $a7d73733e3af3ae6$var$load("i8VlQ"),
    $a7d73733e3af3ae6$var$load("7do1E"),
    $a7d73733e3af3ae6$var$load("77dkW"),
    $a7d73733e3af3ae6$var$load("g9CVe"),
    $a7d73733e3af3ae6$var$load("4t1qI"),
    $a7d73733e3af3ae6$var$load("fSobj"),
    $a7d73733e3af3ae6$var$load("74u2y"),
    $a7d73733e3af3ae6$var$load("6wr18"),
    $a7d73733e3af3ae6$var$load("kjZZD"),
    $a7d73733e3af3ae6$var$load("jsqco"),
    $a7d73733e3af3ae6$var$load("851iy"),
    $a7d73733e3af3ae6$var$load("kHOMt"),
    $a7d73733e3af3ae6$var$load("dRpV3"),
    $a7d73733e3af3ae6$var$load("ffEVr"),
    $a7d73733e3af3ae6$var$load("dTsOE"),
    $a7d73733e3af3ae6$var$load("jwTn5"),
    $a7d73733e3af3ae6$var$load("aYdgM"),
    $a7d73733e3af3ae6$var$load("6u1hm"),
    $a7d73733e3af3ae6$var$load("9vLZO"),
    $a7d73733e3af3ae6$var$load("hx8rI"),
    $a7d73733e3af3ae6$var$load("2vAWg"),
    $a7d73733e3af3ae6$var$load("7cABH"),
    $a7d73733e3af3ae6$var$load("4UuEP"),
    $a7d73733e3af3ae6$var$load("75xVF"),
    $a7d73733e3af3ae6$var$load("2uVTT"),
    $a7d73733e3af3ae6$var$load("hhss7"),
    $a7d73733e3af3ae6$var$load("Wowvf"),
    $a7d73733e3af3ae6$var$load("cJcjb"),
    $a7d73733e3af3ae6$var$load("hJpvQ"),
    $a7d73733e3af3ae6$var$load("bIPPg"),
    $a7d73733e3af3ae6$var$load("lnKog"),
    $a7d73733e3af3ae6$var$load("9ftJe"),
    $a7d73733e3af3ae6$var$load("h3ABO"),
    $a7d73733e3af3ae6$var$load("kC80R"),
    $a7d73733e3af3ae6$var$load("7EorR"),
    $a7d73733e3af3ae6$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("4eWti", function(module, exports) {

let $3165d37858d1ef81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3165d37858d1ef81$var$load("2YffH"),
    $3165d37858d1ef81$var$load("lqFMg"),
    $3165d37858d1ef81$var$load("6ppWw"),
    $3165d37858d1ef81$var$load("dV96N"),
    $3165d37858d1ef81$var$load("4QkRU"),
    $3165d37858d1ef81$var$load("eBRUf"),
    $3165d37858d1ef81$var$load("g2Huf"),
    $3165d37858d1ef81$var$load("cOwGZ"),
    $3165d37858d1ef81$var$load("44eor"),
    $3165d37858d1ef81$var$load("8faeS"),
    $3165d37858d1ef81$var$load("h4Nf7"),
    $3165d37858d1ef81$var$load("7f9Fz"),
    $3165d37858d1ef81$var$load("8YSo7"),
    $3165d37858d1ef81$var$load("i8VlQ"),
    $3165d37858d1ef81$var$load("7do1E"),
    $3165d37858d1ef81$var$load("77dkW"),
    $3165d37858d1ef81$var$load("g9CVe"),
    $3165d37858d1ef81$var$load("4t1qI"),
    $3165d37858d1ef81$var$load("fSobj"),
    $3165d37858d1ef81$var$load("74u2y"),
    $3165d37858d1ef81$var$load("6wr18"),
    $3165d37858d1ef81$var$load("kjZZD"),
    $3165d37858d1ef81$var$load("jsqco"),
    $3165d37858d1ef81$var$load("851iy"),
    $3165d37858d1ef81$var$load("kHOMt"),
    $3165d37858d1ef81$var$load("dRpV3"),
    $3165d37858d1ef81$var$load("ffEVr"),
    $3165d37858d1ef81$var$load("dTsOE"),
    $3165d37858d1ef81$var$load("jwTn5"),
    $3165d37858d1ef81$var$load("aYdgM"),
    $3165d37858d1ef81$var$load("6u1hm"),
    $3165d37858d1ef81$var$load("9vLZO"),
    $3165d37858d1ef81$var$load("hx8rI"),
    $3165d37858d1ef81$var$load("2vAWg"),
    $3165d37858d1ef81$var$load("7cABH"),
    $3165d37858d1ef81$var$load("4UuEP"),
    $3165d37858d1ef81$var$load("75xVF"),
    $3165d37858d1ef81$var$load("2uVTT"),
    $3165d37858d1ef81$var$load("hhss7"),
    $3165d37858d1ef81$var$load("Wowvf"),
    $3165d37858d1ef81$var$load("cJcjb"),
    $3165d37858d1ef81$var$load("hJpvQ"),
    $3165d37858d1ef81$var$load("bIPPg"),
    $3165d37858d1ef81$var$load("lnKog"),
    $3165d37858d1ef81$var$load("9ftJe"),
    $3165d37858d1ef81$var$load("h3ABO"),
    $3165d37858d1ef81$var$load("kC80R"),
    $3165d37858d1ef81$var$load("7EorR"),
    $3165d37858d1ef81$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("fUm9P", function(module, exports) {

let $b94d45fa52b8e14d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b94d45fa52b8e14d$var$load("7do1E"),
    $b94d45fa52b8e14d$var$load("77dkW"),
    $b94d45fa52b8e14d$var$load("2YffH"),
    $b94d45fa52b8e14d$var$load("lqFMg"),
    $b94d45fa52b8e14d$var$load("6ppWw"),
    $b94d45fa52b8e14d$var$load("dV96N"),
    $b94d45fa52b8e14d$var$load("hJpvQ"),
    $b94d45fa52b8e14d$var$load("eBRUf"),
    $b94d45fa52b8e14d$var$load("g2Huf"),
    $b94d45fa52b8e14d$var$load("cOwGZ"),
    $b94d45fa52b8e14d$var$load("44eor"),
    $b94d45fa52b8e14d$var$load("8faeS"),
    $b94d45fa52b8e14d$var$load("h4Nf7"),
    $b94d45fa52b8e14d$var$load("7f9Fz"),
    $b94d45fa52b8e14d$var$load("8YSo7"),
    $b94d45fa52b8e14d$var$load("i8VlQ"),
    $b94d45fa52b8e14d$var$load("g9CVe"),
    $b94d45fa52b8e14d$var$load("4t1qI"),
    $b94d45fa52b8e14d$var$load("fSobj"),
    $b94d45fa52b8e14d$var$load("74u2y"),
    $b94d45fa52b8e14d$var$load("6wr18"),
    $b94d45fa52b8e14d$var$load("kjZZD"),
    $b94d45fa52b8e14d$var$load("jsqco"),
    $b94d45fa52b8e14d$var$load("851iy"),
    $b94d45fa52b8e14d$var$load("kHOMt"),
    $b94d45fa52b8e14d$var$load("dRpV3"),
    $b94d45fa52b8e14d$var$load("ffEVr"),
    $b94d45fa52b8e14d$var$load("jwTn5"),
    $b94d45fa52b8e14d$var$load("aYdgM"),
    $b94d45fa52b8e14d$var$load("6u1hm"),
    $b94d45fa52b8e14d$var$load("9vLZO"),
    $b94d45fa52b8e14d$var$load("hx8rI"),
    $b94d45fa52b8e14d$var$load("2vAWg"),
    $b94d45fa52b8e14d$var$load("7cABH"),
    $b94d45fa52b8e14d$var$load("4UuEP"),
    $b94d45fa52b8e14d$var$load("75xVF"),
    $b94d45fa52b8e14d$var$load("bIPPg"),
    $b94d45fa52b8e14d$var$load("2uVTT"),
    $b94d45fa52b8e14d$var$load("hhss7"),
    $b94d45fa52b8e14d$var$load("Wowvf"),
    $b94d45fa52b8e14d$var$load("cJcjb"),
    $b94d45fa52b8e14d$var$load("9ftJe"),
    $b94d45fa52b8e14d$var$load("h3ABO"),
    $b94d45fa52b8e14d$var$load("kC80R"),
    $b94d45fa52b8e14d$var$load("7EorR"),
    $b94d45fa52b8e14d$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("94aeZ", function(module, exports) {

let $699c6e6563f30de6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $699c6e6563f30de6$var$load("7do1E"),
    $699c6e6563f30de6$var$load("77dkW"),
    $699c6e6563f30de6$var$load("2YffH"),
    $699c6e6563f30de6$var$load("lqFMg"),
    $699c6e6563f30de6$var$load("6ppWw"),
    $699c6e6563f30de6$var$load("dV96N"),
    $699c6e6563f30de6$var$load("eBRUf"),
    $699c6e6563f30de6$var$load("g2Huf"),
    $699c6e6563f30de6$var$load("cOwGZ"),
    $699c6e6563f30de6$var$load("44eor"),
    $699c6e6563f30de6$var$load("8faeS"),
    $699c6e6563f30de6$var$load("h4Nf7"),
    $699c6e6563f30de6$var$load("7f9Fz"),
    $699c6e6563f30de6$var$load("8YSo7"),
    $699c6e6563f30de6$var$load("i8VlQ"),
    $699c6e6563f30de6$var$load("g9CVe"),
    $699c6e6563f30de6$var$load("4t1qI"),
    $699c6e6563f30de6$var$load("fSobj"),
    $699c6e6563f30de6$var$load("74u2y"),
    $699c6e6563f30de6$var$load("6wr18"),
    $699c6e6563f30de6$var$load("kjZZD"),
    $699c6e6563f30de6$var$load("jsqco"),
    $699c6e6563f30de6$var$load("851iy"),
    $699c6e6563f30de6$var$load("kHOMt"),
    $699c6e6563f30de6$var$load("dRpV3"),
    $699c6e6563f30de6$var$load("ffEVr"),
    $699c6e6563f30de6$var$load("jwTn5"),
    $699c6e6563f30de6$var$load("aYdgM"),
    $699c6e6563f30de6$var$load("6u1hm"),
    $699c6e6563f30de6$var$load("9vLZO"),
    $699c6e6563f30de6$var$load("hx8rI"),
    $699c6e6563f30de6$var$load("2vAWg"),
    $699c6e6563f30de6$var$load("7cABH"),
    $699c6e6563f30de6$var$load("4UuEP"),
    $699c6e6563f30de6$var$load("75xVF"),
    $699c6e6563f30de6$var$load("2uVTT"),
    $699c6e6563f30de6$var$load("hhss7"),
    $699c6e6563f30de6$var$load("Wowvf"),
    $699c6e6563f30de6$var$load("cJcjb"),
    $699c6e6563f30de6$var$load("hJpvQ"),
    $699c6e6563f30de6$var$load("bIPPg"),
    $699c6e6563f30de6$var$load("lnKog"),
    $699c6e6563f30de6$var$load("9ftJe"),
    $699c6e6563f30de6$var$load("h3ABO"),
    $699c6e6563f30de6$var$load("kC80R"),
    $699c6e6563f30de6$var$load("7EorR"),
    $699c6e6563f30de6$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("jKDx8", function(module, exports) {

let $e610fab856b7a8e2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e610fab856b7a8e2$var$load("7do1E"),
    $e610fab856b7a8e2$var$load("77dkW"),
    $e610fab856b7a8e2$var$load("2YffH"),
    $e610fab856b7a8e2$var$load("lqFMg"),
    $e610fab856b7a8e2$var$load("6ppWw"),
    $e610fab856b7a8e2$var$load("dV96N"),
    $e610fab856b7a8e2$var$load("eBRUf"),
    $e610fab856b7a8e2$var$load("g2Huf"),
    $e610fab856b7a8e2$var$load("cOwGZ"),
    $e610fab856b7a8e2$var$load("44eor"),
    $e610fab856b7a8e2$var$load("8faeS"),
    $e610fab856b7a8e2$var$load("h4Nf7"),
    $e610fab856b7a8e2$var$load("7f9Fz"),
    $e610fab856b7a8e2$var$load("8YSo7"),
    $e610fab856b7a8e2$var$load("i8VlQ"),
    $e610fab856b7a8e2$var$load("g9CVe"),
    $e610fab856b7a8e2$var$load("4t1qI"),
    $e610fab856b7a8e2$var$load("fSobj"),
    $e610fab856b7a8e2$var$load("74u2y"),
    $e610fab856b7a8e2$var$load("6wr18"),
    $e610fab856b7a8e2$var$load("kjZZD"),
    $e610fab856b7a8e2$var$load("jsqco"),
    $e610fab856b7a8e2$var$load("851iy"),
    $e610fab856b7a8e2$var$load("kHOMt"),
    $e610fab856b7a8e2$var$load("dRpV3"),
    $e610fab856b7a8e2$var$load("ffEVr"),
    $e610fab856b7a8e2$var$load("jwTn5"),
    $e610fab856b7a8e2$var$load("aYdgM"),
    $e610fab856b7a8e2$var$load("6u1hm"),
    $e610fab856b7a8e2$var$load("9vLZO"),
    $e610fab856b7a8e2$var$load("hx8rI"),
    $e610fab856b7a8e2$var$load("2vAWg"),
    $e610fab856b7a8e2$var$load("7cABH"),
    $e610fab856b7a8e2$var$load("4UuEP"),
    $e610fab856b7a8e2$var$load("75xVF"),
    $e610fab856b7a8e2$var$load("2uVTT"),
    $e610fab856b7a8e2$var$load("hhss7"),
    $e610fab856b7a8e2$var$load("Wowvf"),
    $e610fab856b7a8e2$var$load("cJcjb"),
    $e610fab856b7a8e2$var$load("hJpvQ"),
    $e610fab856b7a8e2$var$load("bIPPg"),
    $e610fab856b7a8e2$var$load("lnKog"),
    $e610fab856b7a8e2$var$load("9ftJe"),
    $e610fab856b7a8e2$var$load("h3ABO"),
    $e610fab856b7a8e2$var$load("kC80R"),
    $e610fab856b7a8e2$var$load("7EorR"),
    $e610fab856b7a8e2$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("lk93G"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("lk93G", function(module, exports) {

let $f8627e0aeed3fccf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f8627e0aeed3fccf$var$load("hJpvQ"),
    $f8627e0aeed3fccf$var$load("bIPPg"),
    $f8627e0aeed3fccf$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.1a1e0621.js.map
